export default "__VITE_ASSET__6F8etM2___"